import React from 'react';

const IconAngleDown = () => {
    return (<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clipRule="evenodd" d="m4.00008 9c-.39053-.39052-.39053-1.02369 0-1.41421.39052-.39053 1.02368-.39053 1.41421 0l5.87871 5.87871c.3905.3905 1.0237.3905 1.4142 0l5.8787-5.87871c.3905-.39053 1.0237-.39053 1.4142 0 .3905.39052.3905 1.02369 0 1.41421l-7.2929 7.2929c-.3905.3905-1.0237.3905-1.4142 0z" fill="rgb(0,0,0)" fillRule="evenodd" /></svg>);
}

export default IconAngleDown;